import React from "react";
import { connect } from "react-redux";
import { firebaseApp, firebaseDb } from "../../../core/firebase";
import Main from "../../components/main";
import Box from "../../components/box";
import H2 from "../../components/h2";
import "./styles.css";

class Key extends React.Component {
  state = {
    key: null,
    madeKeyRequest: false,
    tooltip: null
  };
  componentDidUpdate(prevProps) {
    if (prevProps.user.uid !== this.props.user.uid) {
      this.setState({ madeKeyRequest: false });
    }

    if (!this.state.madeKeyRequest) {
      this.setState({ madeKeyRequest: true });
      firebaseDb
        .ref(`/user/${this.props.user.uid}/key`)
        .once("value", snapshot => {
          if (snapshot.val()) {
            this.setState({ key: snapshot.val() });
          } else {
            firebaseApp
              .auth()
              .currentUser.getToken(/* forceRefresh */ true)
              .then(idToken => {
                fetch(
                  `https://us-central1-project-1029735015520686877.cloudfunctions.net/keySystem?idToken=${idToken}`
                )
                  .then(res => res.json())
                  .then(obj => this.setState({ key: obj.key }));
              });
          }
        });
    }
  }

  handleKeyClick = () => {
    navigator.clipboard.writeText(this.state.key).then(
      () => {
        this.setState({ tooltip: "Key Copied" });
      },
      err => {
        console.error("Async: Could not copy text: ", err);
      }
    );
  };
  render() {
    return this.props.user.uid ? (
      <Main>
        <Box>
          <H2>Your Key (Click to copy)</H2>
          <div
            className="keybox"
            onClick={this.handleKeyClick}
            onMouseEnter={() => this.setState({ tooltip: "Copy Key" })}
            onMouseLeave={() => this.setState({ tooltip: null })}
          >
            {this.state.tooltip ? (
              <div className="tooltip">{this.state.tooltip}</div>
            ) : null}
            {this.state.key ? this.state.key : "Please wait..."}
          </div>
        </Box>
      </Main>
    ) : (
      <Main>
        <Box>
          <H2>You need to be signed in to get your key.</H2>
        </Box>
      </Main>
    );
  }
}

const mapStateToProps = state => ({ user: state.user });

export default connect(mapStateToProps)(Key);



/** WEBPACK FOOTER **
 ** ./src/views/pages/key/index.js
 **/